import { createRouter, createWebHistory } from "vue-router";
import AuthPage from "./components/AuthPage.vue";
import OrderPage from "./components/OrderPage.vue";
// import NotFound from "./components/NotFound.vue";
import CarriersPage from "./components/CarriersPage.vue";
import AccountPage from "./components/AccountPage.vue";
import OrderEditingPage from "./components/OrderEditingPage.vue";
import OrderData from "./components/Account/Order/OrderData.vue";
import NewOrdersPage from "./components/NewOrdersPage.vue";
import OrderHistoryPage from "./components/OrderHistoryPage.vue";
import MyOrdersPage from "./components/Account/Order/MyOrdersPage.vue";
import RecoveryPaaswordPage from "./components/RecoveryPasswordPage.vue";
import ConfirmEmailLink from "./components/ConfirmEmailLink.vue";
//Поменять название
import ProfilePage from "./components/NewProfilePage.vue";
import CalcPage from "./components/CalculatorComp.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: "/my_orders",
        component: MyOrdersPage,
        meta: {
          title: "Мои заказы на сервисе - Medmobil",
          description: "На странице 'Мои заказы' вы можете просмотреть свои активные и завершенные заказы медицинских перевозок.",
          keywords: "мои заказы, медицинские перевозки, активные заказы, завершенные заказы"
        },
      },
      {
        path: "/new_orders",
        component: NewOrdersPage,
        meta: {
          title: "Создание заказа на сервисе - Medmobil",
          description: "На странице 'Создание заказа' вы можете заполнить информацию о пациенте и медицинской перевозке, чтобы оформить новый заказ.",
          keywords: "создание заказа, медицинские перевозки, заполнить информацию, оформить заказ"
        },
      },
      {
        path: "/order_history",
        component: OrderHistoryPage,
        meta: {
          title: "История заказов на сервисе - Medmobil",
          description: "На странице 'История заказов' вы можете просмотреть историю своих прошлых заказов медицинских перевозок.",
          keywords: "история заказов, медицинские перевозки, прошлые заказы"
        },
      },
      {
        path: "/carriers",
        component: CarriersPage,
        meta: {
          title: "Станьте нашим партнером - Medmobil",
          description: "Приглашаем к сотрудничеству компании, специализирующиеся на медицинских перевозках. Наше партнерство будет взаимовыгодным."
        },
      },
      {
        path: "/order_data/:username/:id",
        component: OrderData,
        meta: {
          title: "Заказ №:id - Medmobil",
          description: "Страница с подробной информацией о заказе №:id медицинских перевозок.",
          keywords: "заказ медицинской перевозки, подробности заказа, информация о заказе"
        },
      },
      {
        name: "orderInfo",
        path: "/order/:id",
        component: OrderEditingPage,
        meta: {
          title: "Заказ - Medmobil",
          description: "",
          keywords: "профиль, учетная запись, настройки, медицинские перевозки"
        },
      },
      {
        name: "profile",
        path: "/my",
        component: ProfilePage,
        meta: {
          title: "Ваш профиль на сервисе - Medmobil",
          description: "Страница 'Ваш профиль' позволяет вам управлять вашей учетной записью и настройками медицинских перевозок.",
          keywords: "профиль, учетная запись, настройки, медицинские перевозки"
        },
      },
      {
        name: 'account',
        path: "/account",
        component: AccountPage,
        meta: {
          title: "Ваш профиль на сервисе - Medmobil",
          description: "Страница 'Ваш профиль' позволяет вам управлять вашей учетной записью и настройками медицинских перевозок.",
          keywords: "профиль, учетная запись, настройки, медицинские перевозки"
        },
      },
      {
        path: "/account/forgot_password",
        component: RecoveryPaaswordPage,
        meta: {
          title: "Изменить пароль на сервисе - Medmobil",
          description: "На странице 'Изменить пароль' вы можете сбросить или изменить свой пароль для учетной записи медицинских перевозок.",
          keywords: "изменить пароль, сбросить пароль, медицинские перевозки, учетная запись"
        },
      },
      {
        name: 'authorization',
        path: "/authorization",
        component: AuthPage,
        meta: {
          title: "Авторизация на сервисе - Medmobil",
          description: "Страница 'Авторизация' позволяет вам войти в свою учетную запись медицинских перевозок или создать новую учетную запись.",
          keywords: "авторизация, вход, регистрация, медицинские перевозки"
        },
      },
      {
        path: "/calculator",
        component: CalcPage,
        meta: {
          title: "Узнать цену - Medmobil",
          description: "Страница позволяет вам заполнить информацию о пациенте и медицинской перевозке, чтобы узнать цену.",
          keywords: "создание заказа, медицинские перевозки, заполнить информацию, оформить заказ"
        },
      },
      {
        name: 'order',
        path: "/order",
        component: OrderPage,
        meta: {
          title: "Создание заказа на сервисе - Medmobil",
          description: "Страница 'Создание заказа' позволяет вам заполнить информацию о пациенте и медицинской перевозке, чтобы оформить новый заказ.",
          keywords: "создание заказа, медицинские перевозки, заполнить информацию, оформить заказ"
        },
      },
    {
      path: "/account/confirmEmail/:uuid/:email/:code",
      component: ConfirmEmailLink,
      meta: {
        title: "Подтверждение почты на сервисе - Medmobil",
        description: "Страница 'Подтверждение почты' предназначена для подтверждения электронной почты при создании учетной записи медицинских перевозок.",
        keywords: "подтверждение почты, медицинские перевозки, электронная почта"
      },
    },
    {
      name: 'CalculatePage',
      path: "/wordpress/calculator",
      component: CalcPage,
      meta: {
        title: "Калькулятор - Medmobil",
        description: "На данной странице вы можете узнать примерную стоимость!",
        keywords: "медицинские перевозки, заказать перевозку, рейтинг перевозчиков, отзывы клиентов, обратная связь, связь"
      },
    },
    // {
    //   name: '404',
    //   path: "/:pathMatch(.*)*",
    //   component: NotFound,
    //   meta: {
    //     title: "Страница не найдена - Medmobil",
    //     description: "Страница, которую вы ищете, не найдена. Пожалуйста, проверьте правильность введенного адреса.",
    //     keywords: "страница не найдена, 404, медицинские перевозки",
    //     "prerender-status-code": "404"
    //   },
    // }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "";
  document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description || "");
  document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords || "");
  document.querySelector('meta[name="prerender-status-code"]').setAttribute('content', to.meta["prerender-status-code"] || "200");
  next();
});

export default router;
